export default __webpack_public_path__ + "static/media/meal.e1c67314.mp4";